import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conegte',
  templateUrl: './conegte.component.html',
  styleUrls: ['./conegte.component.css']
})
export class ConegteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
